const writingExam = {
  "ko": {
    "homeTitle": "무작위 영작 훈련",
    "heroPrompt": "세 장의 카드, 새로운 문장",
    "todayRecords": "오늘의 영작 훈련",
    "earlierRecords": "이전 학습 기록",
    "streakTitle": "오늘도 학습 완료!",
    "streakMessage": "{count}일 연속 학습을 이어갔어요!",
    "stepPosition": "{step}/3단계",
    "steps": "영작 훈련 단계",
    "step1": "질문",
    "step2": "답 확인",
    "step3": "반복",
    "title": "영작 훈련",
    "intro": "중점 표현으로 직접 쓰고, 모범답안을 소리 내어 연습하세요.",
    "start": "영작학습 시작",
    "resume": "이어서 학습하기",
    "done": "오늘의 학습 완료",
    "daily": "하루 세 문장",
    "homeProgress": "오늘 {count}/3 문장 완료",
    "homeComplete": "오늘 세 문장 완료",
    "unlimited": "한 번에 3문장 · 하루 횟수 제한 없음",
    "startAgain": "다시 영작학습 시작",
    "expandRecord": "답안과 채점 의견 펼치기",
    "collapseRecord": "답안과 채점 의견 접기",
    "preparing": "영작 채점 서비스를 준비 중입니다.",
    "retry": "다시 불러오기",
    "stats": "영작 통계",
    "totalSentences": "전체 {count}문장",
    "recentAverage": "최근 10문장 평균 {score}",
    "averageUnavailable": "계산 불가",
    "explanation": "해설",
    "count": "채점 문장",
    "average": "평균 점수",
    "perfect": "만점 횟수",
    "savedCount": "저장한 문장",
    "history": "영작 기록",
    "search": "영작 기록 검색",
    "searchHint": "문제 또는 답안 검색",
    "filters": "영작 기록 필터",
    "all": "전체",
    "unsaved": "미저장",
    "saved": "저장 완료",
    "review": "복습",
    "loading": "불러오는 중…",
    "empty": "아직 표시할 영작 기록이 없습니다.",
    "reference": "모범답안",
    "answer": "내 답안",
    "addToNote": "내 노트로 가져오기",
    "saveTitle": "내 노트로 가져오기",
    "saving": "가져오는 중…",
    "created": "모범답안을 내 노트로 가져왔습니다.",
    "saveHint": "모범답안을 레벨 1 카드로 가져옵니다. 학습 목표는 {goal}점입니다.",
    "pagination": "영작 기록 페이지",
    "previous": "이전 페이지",
    "next": "다음 페이지",
    "exam": "영작 시험",
    "later": "나중에 이어하기",
    "englishAnswer": "너의 답변은?",
    "grading": "채점 중…",
    "retryGrade": "채점 다시 시도",
    "submit": "답안 제출",
    "pass": "다음문장으로",
    "drawingHint": "카드 위에 자유롭게 적어 보세요",
    "clearDrawing": "그림 지우기",
    "answerCard": "질문과 답안 확인 카드",
    "earnedPoints": "획득 포인트 {points}점",
    "reject": "문제 거부",
    "trainerMin": "트레이너 민",
    "question": "문제",
    "practiceEight": "다음으로",
    "rejectTitle": "이 표현을 제외할까요?",
    "rejectWarning": "이 표현의 모든 문제는 앞으로 다시 출제되지 않습니다. 이번에만 건너뛰려면 ‘패스’를 이용하세요.",
    "rejectConfirm": "다시 출제하지 않기",
    "cancel": "취소",
    "complete": "이번 영작학습을 마쳤습니다.",
    "resultTitle": "영작 학습 결과",
    "resultPaused": "진행을 저장했어요. 다음에 이어서 학습할 수 있어요.",
    "resultCompleted": "반복 완료 문장",
    "resultAverage": "평균 채점 점수",
    "resultRepeats": "반복 횟수",
    "resultPoints": "획득 포인트",
    "resultRecords": "이번 수업 기록",
    "resultTime": "학습 시간",
    "resultGraded": "채점한 문장",
    "resultSkipped": "건너뛴 문장",
    "resultBack": "돌아가기",
    "noReview": "복습할 영작 기록이 없습니다.",
    "failed": "요청을 처리하지 못했습니다. 다시 시도해 주세요.",
    "reviewTitle": "영작 기록 복습",
    "progress": "{count}/3 문장 완료",
    "position": "문장 {number} / 3",
    "expression": "이 표현을 사용하세요:",
    "score": "{score}점",
    "scoreLabel": "채점 점수 {score}점",
    "repeat": "반복 {count}/8",
    "breakdown": "표현 {expression}/40 · 의미 {meaning}/40 · 문법 {grammar}/20"
  },
  "en": {
    "homeTitle": "Random writing practice",
    "heroPrompt": "Three cards, new sentences",
    "todayRecords": "Today's writing practice",
    "earlierRecords": "Earlier practice",
    "streakTitle": "Training complete!",
    "streakMessage": "You've trained for {count} consecutive days!",
    "stepPosition": "Step {step}/3",
    "steps": "Writing practice steps",
    "step1": "Question",
    "step2": "Review",
    "step3": "Repeat",
    "title": "Writing practice",
    "intro": "Write with a target expression, then practice the reference answer aloud.",
    "start": "Start writing practice",
    "resume": "Continue practice",
    "done": "Today’s practice complete",
    "daily": "Three sentences a day",
    "homeProgress": "{count}/3 sentences completed today",
    "homeComplete": "Today’s three sentences complete",
    "unlimited": "3 sentences per session · no daily limit",
    "startAgain": "Start another writing session",
    "expandRecord": "Expand answer and feedback",
    "collapseRecord": "Collapse answer and feedback",
    "preparing": "Writing grading is not configured yet.",
    "retry": "Reload",
    "stats": "Writing statistics",
    "totalSentences": "{count} sentences total",
    "recentAverage": "Latest 10 average: {score}",
    "averageUnavailable": "unavailable",
    "explanation": "Feedback",
    "count": "Graded sentences",
    "average": "Average score",
    "perfect": "Perfect answers",
    "savedCount": "Saved sentences",
    "history": "Writing history",
    "search": "Search writing history",
    "searchHint": "Search questions or answers",
    "filters": "Writing history filters",
    "all": "All",
    "unsaved": "Not saved",
    "saved": "Saved",
    "review": "Review",
    "loading": "Loading…",
    "empty": "No writing records to show yet.",
    "reference": "Reference",
    "answer": "Your answer",
    "addToNote": "Import to My Notes",
    "saveTitle": "Import to My Notes",
    "saving": "Importing…",
    "created": "The reference answer was imported to your note.",
    "saveHint": "Import the reference answer as a level 1 card with a {goal}-point learning goal.",
    "pagination": "Writing history pages",
    "previous": "Previous page",
    "next": "Next page",
    "exam": "Writing exam",
    "later": "Continue later",
    "englishAnswer": "What's your answer?",
    "grading": "Grading…",
    "retryGrade": "Retry grading",
    "submit": "Submit answer",
    "pass": "Next sentence",
    "drawingHint": "Draw freely on the card",
    "clearDrawing": "Clear drawing",
    "answerCard": "Question and answers card",
    "earnedPoints": "{points} points earned",
    "reject": "Reject problem",
    "trainerMin": "Trainer Min",
    "question": "Question",
    "practiceEight": "Next",
    "rejectTitle": "Exclude this expression?",
    "rejectWarning": "No problems for this expression will appear again. Choose Pass to skip it only this time.",
    "rejectConfirm": "Do not show again",
    "cancel": "Cancel",
    "complete": "You have completed this writing session.",
    "resultTitle": "Writing lesson results",
    "resultPaused": "Progress saved. You can continue this lesson later.",
    "resultCompleted": "Sentences fully practiced",
    "resultAverage": "Average grading score",
    "resultRepeats": "Repetitions",
    "resultPoints": "Points earned",
    "resultRecords": "This lesson",
    "resultTime": "Practice time",
    "resultGraded": "Graded sentences",
    "resultSkipped": "Skipped sentences",
    "resultBack": "Back",
    "noReview": "There are no writing records to review.",
    "failed": "The request failed. Please try again.",
    "reviewTitle": "Writing history review",
    "progress": "{count}/3 sentences completed",
    "position": "Sentence {number} / 3",
    "expression": "Use this expression:",
    "score": "{score} points",
    "scoreLabel": "Writing score {score}",
    "repeat": "Repeat {count}/8",
    "breakdown": "Expression {expression}/40 · Meaning {meaning}/40 · Grammar {grammar}/20"
  }
};
export default writingExam;
